"use client";

import PhosphorIcon from "@/shared/components/common/PhosphorIcon";
import { useState } from "react";

export interface PageContentFAQItem {
  answer: string;
  question: string;
}

interface PageContentFAQProps {
  items: PageContentFAQItem[];
  className?: string;
}

export default function PageContentFAQ({
  items,
  className = "mb-32",
}: PageContentFAQProps) {
  const [open, setOpen] = useState<number | null>(0);

  if (!items.length) return null;

  return (
    <section
      id="faq"
      className={`${className} scroll-mt-28 rounded-2xl border border-[rgb(229,231,235)] bg-white p-5`}
    >
      <h2 className="mb-4 text-base font-bold text-[#1a1a2e]">
        سوالات متداول
      </h2>

      <div className="space-y-2">
        {items.map((item, index) => {
          const isOpen = open === index;

          return (
            <div
              key={`${item.question}-${index}`}
              className="overflow-hidden rounded-xl border border-[rgb(229,231,235)]"
            >
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : index)}
                className="flex w-full items-center justify-between gap-3 p-4 text-right transition-colors hover:bg-gray-50"
                aria-expanded={isOpen}
              >
                <span className="flex items-center gap-2.5">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-[rgb(229,231,235)] text-xs text-[#6b7280]">
                    ?
                  </span>
                  <span className="text-sm font-semibold text-[#1a1a2e]">
                    {item.question}
                  </span>
                </span>
                <PhosphorIcon
                  name={isOpen ? "CaretUp" : "CaretDown"}
                  size={16}
                  className="shrink-0 text-[#6b7280]"
                />
              </button>
              {isOpen && (
                <div
                  className="border-t border-[#f0f0f0] px-4 pb-4 pt-3 text-sm leading-6 text-[#6b7280]"
                  dangerouslySetInnerHTML={{ __html: item.answer }}
                />
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
